/**
 * FlahaSOIL v2 — ReportBrandStrip (Phase 10D.1).
 *
 * Bottom value strip on the report cover page.
 * Displays the four platform value pillars, inspired by the approved
 * cover-reference design.
 */
import { Box, Stack, Typography } from "@mui/material";
import { flahaSoilColors } from "../../../../theme/flahaSoilTheme";

const VALUE_PILLARS = [
  "Soil science expertise",
  "Reliable data",
  "Actionable insights",
  "Better decisions",
] as const;

export function ReportBrandStrip() {
  return (
    <Box
      sx={{
        backgroundColor: flahaSoilColors.organicGreen,
        px: 4,
        py: 2,
      }}
    >
      <Stack
        direction="row"
        spacing={0}
        divider={
          <Box
            component="span"
            sx={{
              alignSelf: "center",
              width: "1px",
              height: "1.2em",
              backgroundColor: "rgba(255,255,255,0.35)",
              mx: 3,
              flexShrink: 0,
            }}
          />
        }
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
      >
        {VALUE_PILLARS.map((pillar) => (
          <Typography
            key={pillar}
            variant="overline"
            sx={{
              color: "#FFFFFF",
              letterSpacing: "0.12em",
              fontWeight: 600,
              fontSize: "0.7rem",
              lineHeight: 1.6,
              whiteSpace: "nowrap",
            }}
          >
            {pillar}
          </Typography>
        ))}
      </Stack>
    </Box>
  );
}
